import { useEffect, useState } from "react";
import { useToasts } from "react-toast-notifications";
import Button from "react-bootstrap/Button";
import CSVReader from "react-csv-reader";

const papaparseOptions = {
  header: true,
  dynamicTyping: true,
  skipEmptyLines: true,
  transformHeader: header => header.toLowerCase().replace(/\W/g, "_")
};

const ImportWelcomeMessages = () => {
  const { addToast } = useToasts();
  const [state, setState] = useState({
    csvData: [],
    isLoading: false
  })

  useEffect(() => {
  }, []);

  const handleForce = (data, fileInfo) =>{
    console.log(data, fileInfo)
    data.forEach(item => {
      let media = new Audio(item.content);
      media.onloadedmetadata = function(){
        const minutes = Math.floor(media.duration / 60);
        const seconds = media.duration - minutes * 60;
        const duration = minutes > 0 ? `${minutes}m ${parseInt(seconds)}s` : `${parseInt(seconds)}s`
        item.duration = duration;
      };
    });
    
    console.log(data);
    setState({...state, csvData: data})
  };

  const handleSave = () => {
    setState({...state, isLoading: true})

    axios.post('/api/administration/welcome-message/import', {
      csvData: state.csvData
    }).then(res => {
      const data = res.data;
      setState({...state, isLoading: false, csvData: []})
      document.querySelector('.csv-input').value = '';
      console.log(data);
      if(data.total == 0)
        return addToast("There's no record found from the imported file.", { appearance: 'info', autoDismiss: true });
        
      addToast(`Successfully updated ${data.total} file${data.total > 0 ? 's.' : '.'}`, { appearance: 'success', autoDismiss: true });
    }).catch(err => {
      setState({...state, isLoading: false})
      addToast("There's an error uploading CSV file.", { appearance: 'error', autoDismiss: true });
      console.log(err)
    })
  }

  return (
    <div>
        <h3 className="mb-4">Import Welcome Messages</h3>
        <div className="w-25">
          <CSVReader
            cssClass="react-csv-input"
            label="Import a CSV file"
            onFileLoaded={handleForce}
            parserOptions={papaparseOptions}
          />

          <Button
            className="mt-2"
            variant="primary"
            disabled={state.isLoading || state.csvData.length === 0}
            onClick={handleSave}>
            {state.isLoading ? (
              <div className="d-flex flex-row align-items-center">
                  <div className="spinner-border text-light mr-2 spinner-border-sm" role="status">
                      <span className="sr-only">Loading...</span>
                  </div>
                  Saving...
              </div>
            ) : (
              'Save'
            )}
            </Button>
        </div>
    </div>
  )
}

export default ImportWelcomeMessages;